<template>
  <LcModal
    v-bind="{ tracking }"
    :close-triggers="['escape', 'click-outside']"
    spacing="small"
    @close="close"
  >
    <div class="lc-info-button__modal">
      <header class="lc-info-button__modal-header">
        <span class="lc-info-button__modal-headline">
          {{ headline }}
        </span>

        <LcButton
          :aria-label="$t('common.modal.close.label')"
          icon="close"
          size="small"
          variant="tertiary"
          @click="close"
        />
      </header>

      <slot v-bind="{ close }" />
    </div>
  </LcModal>
</template>

<script lang="ts" setup>
import type { TrackingImpressionProps } from '#tracking/app/types/tracking'

type ScratchcardInfoModalEmits = {
  (e: 'close'): void
}

type ScratchcardInfoModalProps = {
  closeButtonAriaLabel?: string
  headline: string
  tracking: TrackingImpressionProps['tracking']
}

const emit = defineEmits<ScratchcardInfoModalEmits>()

defineProps<ScratchcardInfoModalProps>()

const close = () => emit('close')
</script>
